import Alpine from 'alpinejs';
window.s1.alpine = Alpine; 
//Alpine.start();